import { render } from "./FleetBundles.vue?vue&type=template&id=1f6f8abb"
import script from "./FleetBundles.vue?vue&type=script&lang=js"
export * from "./FleetBundles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__